module.exports = __webpack_public_path__ + "img/empty@2x.98ed036b.png";